<script setup lang="ts">
import TutoringPackageBrowser from '~components/admin/TutoringPackageBrowser.vue'
import SelfLink from '~components/widgets/SelfLink.vue'
</script>

<template>
  <b-container fluid>
    <h1><self-link href="/admin/orders/tutoring">Tutoring Packages</self-link></h1>
    <hr>
    <tutoring-package-browser />
  </b-container>
</template>
